import { endpoints, request } from '!core/api';

export const questionnaireServices = {
  getQuestionnaires: ({ holderCode, openingRequestId }) =>
    request.get(
      endpoints.backoffice(
        `wsbGetSurveyData?${
          openingRequestId
            ? `openingRequestId=${openingRequestId}`
            : `holderCode=${holderCode}`
        }`,
      ),
    ),
  postSubmitQuestionnaire: ({
    openingRequestId,
    holderCode,
    surveyId,
    answers,
  }) =>
    request.put(
      endpoints.backoffice(
        `wsbSubmitQuestionnaire?${
          openingRequestId && `openingRequestId=${openingRequestId}`
        }&holderCode=${holderCode}&surveyId=${surveyId}&answers=${answers}`,
      ),
    ),
};
